export default "__VITE_ASSET__VC6XBIYz__"